import * as React from "react";
const SvgArrowDownCheckmark = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="m6.417 6.908 3.825 3.825 3.825-3.825 1.175 1.183-5 5-5-5 1.175-1.183Z" fill="currentColor" /></svg>;
export default SvgArrowDownCheckmark;